// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"_2-cQ8KMlaYak7Nh8YF6qfq"};